import { Route, Routes, Navigate } from "react-router-dom";
import Home from "./components/Home";
import AboutUs from './components/AboutUs';


const AppRoutes = () => {
    return (
        <div>
            <Routes>
                <Route>
                    <Route exact path="/" Component={Home} />
                    <Route path="/home" Component={Home} />
                    <Route path="*" element={<Navigate to="/home" />} />
                    <Route path="/about-us" Component={AboutUs}/>
                </Route>
            </Routes>
        </div>
        )
}

export default AppRoutes;